import ReqClient from './request.class'
import { Message } from 'view-design'
import { HTMLEncode } from '@/common/js/api'
/**
 * @description: 获取财务充值记录
 * @param {*} data
 */
export async function getFinanceRechargeLog(params) {
  const Req = new ReqClient({
    url: '/api/ptom/accountOrder/rechargeRecord',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取财务转账记录
 * @param {*} data
 */
export async function getFinanceTransferLog(params) {
  const Req = new ReqClient({
    url: '/api/ptom/accountOrder/transferRecord',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 获取财务对账数据
 * @param {*} data
 */
export async function getAccountFinance(params) {
  const Req = new ReqClient({
    url: '/api/ptom/accountFinance/page',
    method: 'GET',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
/**
 * @description: 财务对账数据导出
 * @param {*} data
 */
export async function exportData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/accountFinance/exportData',
    method: 'POST',
    data,
    responseType: 'blob'
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

/**
 * @description: 财务对账数据重跑
 * @param {*} data
 */
export async function reRunData(data) {
  const Req = new ReqClient({
    url: '/api/ptom/accountFinance/reRunData',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    if (e.status === 200 && e.data.code === 0) {
      Message.success({ closable: true, duration: 5, content: HTMLEncode(e.data.msg) })
    } else {
      Req.handleError(e)
    }
    return false
  }
}

/**
 * @description: 财务对账数据导入
 * @param {*} data
 */
export async function importRebate(params) {
  const Req = new ReqClient({
    url: '/api/ptom/accountFinance/importRebate',
    method: 'POST',
    params
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
